module.exports = [10,20,30,40,50,60,70,80,90,100]


//////////////////
// WEBPACK FOOTER
// ./src/db/dimensionen.json
// module id = 619
// module chunks = 0